import React from 'react';
import { useDispatch } from 'react-redux';

import Textarea from '../../../components/Textarea';
import FormInput from '../../../components/FormInput';
import { COMMENT_CONTACT } from '../../../utils/const';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';

const ContactUsBold = ({
  data: { title, description, fullName, emailOrWebsite },
  locales: { portfolio, portfolioWeb },
  titleColor,
  textColor,
  backgroundSection,
  backgroundButton,
  textButtonColor,
  disabled = false,
}) => {
  const scrollToTop = () => {
    const element = document.getElementById('scroll');
    element.scrollIntoView();
  };

  const {
    portfolio: { updateSectionField },
  } = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;

    updateSectionField({
      sectionName: 'contactUs',
      field: name,
      value,
      name,
    });
  };

  return (
    <div
      className="contact-us-bold relative"
      style={{ backgroundColor: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_CONTACT} />
      <div className="header">
        <div
          className="bold-title title custom-font-title"
          style={{ color: titleColor }}
        >
          {portfolio.contactUs.sectionTitle}
        </div>
        <div>
          <button
            className="scroll-top custom-font-body"
            style={{
              backgroundColor: backgroundButton,
              color: textButtonColor,
            }}
            onClick={scrollToTop}
          >
            {portfolioWeb.contactUs.scrollTop}
            <i className="icon-Arrow-Top" />
          </button>
        </div>
      </div>
      <div className="fields">
        <div className="textarea-boldTemplate description">
          <Textarea
            name="textarea"
            delay={700}
            value={description}
            onChange={(e) =>
              updateSectionField({
                sectionName: 'contactUs',
                field: 'description',
                name: 'contactUsText',
                value: e.target.value,
              })
            }
            className="textarea-bold custom-font-body"
            placeholder={portfolio.page.descriptionPlaceholder}
            style={{ color: textColor }}
            disabled={disabled}
          />
        </div>
        <FormInput
          name="fullName"
          defaultValue={fullName}
          delay={700}
          placeholder={portfolio.contactUs.newForm.fullName}
          onChange={handleChange}
          className="form_input custom-font-body"
          style={{ color: textColor }}
          disabled={disabled}
        />
        <FormInput
          name="emailOrWebsite"
          defaultValue={emailOrWebsite}
          delay={700}
          placeholder={portfolio.contactUs.newForm.emailOrWebsite}
          onChange={handleChange}
          className="form_input custom-font-body"
          style={{ color: textColor }}
          disabled={disabled}
        />
      </div>

      <div
        className="footer custom-font-body"
        style={{ borderColor: titleColor, color: textColor }}
      >
        <div>{`© ${title}. ${portfolioWeb.contactUs.rightsReserve}`}</div>
        <div>
          {portfolioWeb.contactUs.buildCreate}
          <span className="company-name">
            {portfolioWeb.contactUs.companyName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactUsBold;
